// extracted by mini-css-extract-plugin
export default {"text":"Skeleton_text__MS29s","image":"Skeleton_image__ag0XL"};